<template>
  <div class="v1-itineraryGet__information">
    <!-- <v1FlightInfomationInternationalFrights
      :itinerary="itinerary"
      :number="3"
      :pageLang="pageLang"
      :pageCountry="pageCountry"
    ></v1FlightInfomationInternationalFrights> -->

    <div class="v1-itineraryGet__column">
      <article class="v1-itineraryDomesticFlights">
        <header class="v1-itineraryDomesticFlights__header" v-if="itinerary.domestic1DepartureCity">
          <h3 class="v1-itineraryDomesticFlights__title">
            {{ itinerary.domesticFlights }}
          </h3>
        </header>

        <v1FlightInfomationDomesticFrights
          :itinerary="itinerary"
          :number="8"
          :pageLang="pageLang"
          :pageCountry="pageCountry"
        ></v1FlightInfomationDomesticFrights>

        <footer class="v1-itineraryDomesticFlights__footer">
          <ul class="v1-itineraryDomesticFlights__footerNote">
            <li
              class="v1-itineraryDomesticFlights__footerNoteItem"
              v-for="disclaimer in filteredDisclaimers"
              :key="disclaimer"
            >
              {{ disclaimer }}
            </li>
          </ul>
          <ul class="v1-itineraryDomesticFlights__info">
            <li
              class="v1-itineraryDomesticFlights__infoItem"
              v-for="n in 2"
              :key="itinerary['info' + n + 'Url']"
            >
              <template v-if="itinerary['info' + n + 'OpenInNewTab']">
                <a
                  :href="itinerary['info' + n + 'Url']"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="v1-itineraryDomesticFlights__infoLink"
                >
                  <svg role="img" class="v1-itineraryDomesticFlights__infoIcon">
                    <use
                      xlink:href="/japan-travel-planner/common/svg/sprite.svg#chevron-right"
                    ></use>
                  </svg>
                  <span class="v1-itineraryDomesticFlights__infoText"
                    >{{ itinerary['info' + n + 'Notes']
                    }}{{ itinerary['info' + n + 'Notes'] && itinerary.langCode === 'zh' ? '' : ' '
                    }}{{ itinerary['info' + n + 'Title'] }}
                    <svg
                      class="v1-itineraryDomesticFlights__infoIconBlank js-external-link "
                      role="img"
                      focusable="false"
                    >
                      <use xlink:href="/japan-travel-planner/common/svg/sprite.svg#blank"></use>
                    </svg>
                  </span>
                </a>
              </template>
              <template v-if="itinerary['info' + n + 'OpenInNewTab'] === false">
                <a
                  :href="itinerary['info' + n + 'Url']"
                  class="v1-itineraryDomesticFlights__infoLink"
                >
                  <svg role="img" class="v1-itineraryDomesticFlights__infoIcon">
                    <use
                      xlink:href="/japan-travel-planner/common/svg/sprite.svg#chevron-right"
                    ></use>
                  </svg>
                  <span class="v1-itineraryDomesticFlights__infoText"
                    >{{ itinerary['info' + n + 'Notes']
                    }}{{ itinerary['info' + n + 'Notes'] && itinerary.langCode === 'zh' ? '' : ' '
                    }}{{ itinerary['info' + n + 'Title'] }}</span
                  >
                </a>
              </template>
            </li>
          </ul>
        </footer>
      </article>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import v1FlightInfomationDomesticFrights from './v1FlightInformationDomesticFlights.vue';
// import v1FlightInfomationInternationalFrights from './v1FlightInfomationInternationalFrights.vue';

const { location } = window;
// const relativePath = location.host + location.pathname;
const pageLang = location.pathname.split('/')[1];
const pageCountry = location.pathname.split('/')[2];
// const langCode = pageLang === 'zh' ? `${pageLang}-${pageCountry}` : pageLang;

function getCurrentData(lang, country, json) {
  /* eslint-disable no-nested-ternary */
  const currentData =
    lang === 'en' && country === 'au'
      ? json['0']
      : lang === 'en' && country === 'gb'
      ? json['1']
      : lang === 'en' && country === 'hk'
      ? json['2']
      : lang === 'en' && country === 'id'
      ? json['3']
      : lang === 'en' && country === 'my'
      ? json['4']
      : lang === 'en' && country === 'ph'
      ? json['5']
      : lang === 'en' && country === 'sg'
      ? json['6']
      : lang === 'en' && country === 'tw'
      ? json['7']
      : lang === 'en' && country === 'us'
      ? json['8']
      : lang === 'en' && country === 'th'
      ? json['9']
      : lang === 'en' && country === 'jp'
      ? json['10']
      : lang === 'en' && country === 'be'
      ? json['11']
      : lang === 'en' && country === 'ca'
      ? json['12']
      : lang === 'en' && country === 'ch'
      ? json['13']
      : lang === 'en' && country === 'es'
      ? json['14']
      : lang === 'en' && country === 'eur'
      ? json['15']
      : lang === 'en' && country === 'in'
      ? json['16']
      : lang === 'en' && country === 'it'
      ? json['17']
      : lang === 'en' && country === 'kh'
      ? json['18']
      : lang === 'en' && country === 'mm'
      ? json['19']
      : lang === 'en' && country === 'vn'
      ? json['20']
      : lang === 'en' && country === 'at'
      ? json['21']
      : lang === 'en' && country === 'cn'
      ? json['22']
      : lang === 'en' && country === 'de'
      ? json['23']
      : lang === 'en' && country === 'fr'
      ? json['24']
      : lang === 'en' && country === 'kr'
      ? json['25']
      : lang === 'ja' && country === 'at'
      ? json['26']
      : lang === 'ja' && country === 'au'
      ? json['27']
      : lang === 'ja' && country === 'be'
      ? json['28']
      : lang === 'ja' && country === 'ca'
      ? json['29']
      : lang === 'ja' && country === 'ch'
      ? json['30']
      : lang === 'ja' && country === 'cn'
      ? json['31']
      : lang === 'ja' && country === 'de'
      ? json['32']
      : lang === 'ja' && country === 'es'
      ? json['33']
      : lang === 'ja' && country === 'eur'
      ? json['34']
      : lang === 'ja' && country === 'fr'
      ? json['35']
      : lang === 'ja' && country === 'gb'
      ? json['36']
      : lang === 'ja' && country === 'hk'
      ? json['37']
      : lang === 'ja' && country === 'id'
      ? json['38']
      : lang === 'ja' && country === 'in'
      ? json['39']
      : lang === 'ja' && country === 'it'
      ? json['40']
      : lang === 'ja' && country === 'jp'
      ? json['41']
      : lang === 'ja' && country === 'kh'
      ? json['42']
      : lang === 'ja' && country === 'mm'
      ? json['43']
      : lang === 'ja' && country === 'my'
      ? json['44']
      : lang === 'ja' && country === 'ph'
      ? json['45']
      : lang === 'ja' && country === 'sg'
      ? json['46']
      : lang === 'ja' && country === 'th'
      ? json['47']
      : lang === 'ja' && country === 'tw'
      ? json['48']
      : lang === 'ja' && country === 'us'
      ? json['49']
      : lang === 'ja' && country === 'vn'
      ? json['50']
      : lang === 'ja' && country === 'kr'
      ? json['51']
      : lang === 'ko' && country === 'kr'
      ? json['52']
      : lang === 'zh' && country === 'cn'
      ? json['53']
      : lang === 'zh' && country === 'tw'
      ? json['54']
      : lang === 'de' && country === 'de'
      ? json['55']
      : lang === 'de' && country === 'at'
      ? json['56']
      : lang === 'fr' && country === 'fr'
      ? json['57']
      : lang === 'th' && country === 'th'
      ? json['58']
      : lang === 'id' && country === 'id'
      ? json['59']
      : lang === 'zh' && country === 'hk'
      ? json['60']
      : lang === 'vi' && country === 'vn'
      ? json['61']
      : json['6'];
  return currentData;
}

export default {
  name: 'v1FlightInfomation',
  components: {
    v1FlightInfomationDomesticFrights,
    // v1FlightInfomationInternationalFrights,
  },
  props: {
    number: {
      type: Number,
    },
  },
  computed: {
    filteredDisclaimers() {
      const disclaimers = [];
      for (let n = 1; n <= 2; n += 1) {
        if (this.itinerary[`flightDisclaimer${n}`]) {
          disclaimers.push(this.itinerary[`flightDisclaimer${n}`]);
        }
      }
      return disclaimers;
    },
  },
  data() {
    return {
      itinerary: {},
      pageLang,
      pageCountry,
    };
  },
  mounted() {
    axios
      .get(`/japan-travel-planner/common/js/itineraries/itinerary${this.number}.json`)
      .then(response => {
        this.itinerary = getCurrentData(pageLang, pageCountry, response.data);
      });
  },
};
</script>
